<template>
  <div v-if="webform" class="my-12 lg:mb-20">
    <Container>
      <div>
        <PageTitle :title="title" />
        <ClientOnly>
          <Webform v-if="webform" :webform="webform" />
        </ClientOnly>
      </div>
    </Container>
  </div>
</template>

<script lang="ts" setup>
import type { WebformFragment } from '#graphql-operations'

defineOptions({
  name: 'PageWebform',
})

definePageMeta({
  name: 'webform-route',
  drupalRoute: true,
})

const nuxtRoute = useRoute()

// Get the data.
const { data: query } = await useAsyncData(nuxtRoute.path, async () => {
  return await useGraphqlQuery('routeWebform', {
    path: nuxtRoute.path,
  }).then((v) => {
    return v.data
  })
})

// Handles redirects and metatags.
const { entity: webform } = await useDrupalRoute<WebformFragment>(query.value)
const title = computed(() => webform?.value.label)

setLanguageLinksFromRoute(query.value)
await renderPageDependencies()
</script>
